import { Component, Input, SimpleChanges } from '@angular/core';
import { filterZeroValuesForChart } from '@piqet-angular/data';
import { commonEnum, ReportFormatEnum } from '@piqet-angular/shared';
import { reportTitals } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-life-cycle-stage-chart',
  templateUrl: './life-cycle-stage-chart.html',
  styleUrls: ['./life-cycle-stage-chart.scss'],
})
export class ReportImpactItemComponent {
  @Input() indicatorDetail: any;
  reportFormatEnum = ReportFormatEnum;
  reportResource = reportTitals;
  chartId: any;
  componentItemsArray: any;
  chartOpacity: any = { value: commonEnum.opacity };
  indicatorsName: string = '';
  generatedChartType: string = 'column';
  componentItemsArrayForChart: any[] = [];

  @Input() isIsoReport = false;

  ngOnChanges(changes: SimpleChanges) {
    this.indicatorDetail = changes['indicatorDetail'].currentValue;
    this.chartId = 'StackedColumnBarChartContainer' + this.indicatorDetail.indicatorId;
    this.componentItemsArray = this.indicatorDetail.componentItems;
    this.chartOpacity = { value: this.indicatorDetail?.opacity };
    this.indicatorsName = this.indicatorDetail?.indicatorName;
    this.componentItemsArrayForChart = filterZeroValuesForChart(this.componentItemsArray);
  }
}
